import Model, { attr, belongsTo } from '@ember-data/model';
import moment from 'moment-timezone';

import type { AsyncBelongsTo } from '@ember-data/model';
import type UserModel from 'later/models/user';

export default class MetaAdUserModel extends Model {
  @attr('string') declare uid: string;
  @attr('string') declare accessToken: string;
  @attr('number') declare tokenExpiresTime?: number;

  @belongsTo('user', { async: true, inverse: 'metaAdUser' }) declare user: AsyncBelongsTo<UserModel>;

  get tokenExpiresAt(): Date | undefined {
    return this.tokenExpiresTime ? moment.unix(this.tokenExpiresTime).toDate() : undefined;
  }
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'meta-ad-user': MetaAdUserModel;
  }
}
